import React, { useEffect, useState } from "react";
import AlertMessage from "../AlertMessage";
import { requestParentResize, blurScreen } from "../../helpers/iframeSource";

function PaymentDetailsPage() {
  const isDesktopScreen = window.innerWidth >= 1310;
  useEffect(() => {
    requestParentResize(isDesktopScreen, 5189, 2808);
  });

  const loading = false;

  useEffect(() => {
    if (loading) {
      blurScreen();
    } else {
      document.body.style.opacity = String(1);
      document.body.style.pointerEvents = "";
    }
  }, [loading]);

  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const onRequestClose = () => {
    setOpenModal(false);
    setModalMessage("");
  };
  const isSmallScreen = window.innerWidth <= 768;
  return (
    <section
      className="flex flex-col "
      style={
        isSmallScreen
          ? { width: "99%", overflow: "hidden" }
          : { width: "100%", overflow: "hidden" }
      }
    >
      <AlertMessage
        openModal={openModal}
        className=""
        requestOnClose={onRequestClose}
        modalMessage={modalMessage}
        isTermsConditionPopUp={false}
      />
      <div
        className={`flex justify-center items-center ${
          isSmallScreen ? "mt-[10%]" : ""
        }`}
      ></div>
    </section>
  );
}

export { PaymentDetailsPage };
